import type { KnownIssuesFeedbackFormProps } from './components/KnownIssuesFeedbackForm';
import type * as lazyIndex from './lazyIndex';
import { createLazyComponent, LazyAction, type LazyComponent, LazyModule } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "SmileyFeedback"*/ './lazyIndex'),
    { name: 'SmileyFeedback' }
);

export const KnownIssuesFeedbackFormHeader: LazyComponent<{}, unknown, void> = createLazyComponent(
    lazyModule,
    m => m.KnownIssuesFeedbackFormHeader
);
export const KnownIssuesFeedbackForm: LazyComponent<KnownIssuesFeedbackFormProps, unknown, void> =
    createLazyComponent(lazyModule, m => m.KnownIssuesFeedbackForm);

export const lazyUpdateFeedbackArea: LazyAction<
    typeof lazyIndex.updateFeedBackArea,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.updateFeedBackArea);
export const lazyHandleFeedbackPostMessageEvents: LazyAction<
    typeof lazyIndex.handleFeedbackPostMessageEvents,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.handleFeedbackPostMessageEvents);

export { odsOrigin } from './FeedbackConstants';
